module.exports = __webpack_public_path__ + "static/media/product_fix_org.487afff7.png";